import type { Agorot } from './types';

export const VAT_RATE = 0.18;

/** NIS (possibly fractional) to integer agorot. */
export const shekelsToAgorot = (nis: number): Agorot => Math.round(nis * 100);

/** Price including 18% VAT from a net price. */
export const addVat = (net: Agorot): Agorot => Math.round(net * (1 + VAT_RATE));
export const removeVat = (gross: Agorot): Agorot => Math.round(gross / (1 + VAT_RATE));
export const vatPortion = (gross: Agorot): Agorot => gross - removeVat(gross);

/**
 * "₪120" / "₪120.50" via Intl; whole-shekel amounts drop the decimals.
 * The currency sign follows the locale's own placement (after the number in he-IL).
 */
export function formatNis(agorot: Agorot, locale = 'he-IL'): string {
  const whole = agorot % 100 === 0;
  return new Intl.NumberFormat(locale, {
    style: 'currency', currency: 'ILS',
    minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2,
  }).format(agorot / 100);
}

/** Percentage of an amount, rounded to whole agorot. */
export const percentOf = (amount: Agorot, percent: number): Agorot => Math.round((amount * percent) / 100);
